import CapexGuidanceTrackerImg from '@assets/images/welligence-assets/images/capex-guidance-tracker.svg';
import EnergyTransitionTargetsTrackerImg from '@assets/images/welligence-assets/images/energy-transition-targets-tracker.svg';
import LicensingRoundImg from '@assets/images/welligence-assets/images/licensing-round-tracker.svg';
import LNGFacilitiesImg from '@assets/images/welligence-assets/images/lng-facilities.svg';
import LicensingImg from '@assets/images/welligence-assets/images/ma-licensing.svg';
import OffshoreExplorationImg from '@assets/images/welligence-assets/images/offshore-exploration-tracker.svg';
import { IndustryTrackerTypeEnum } from '@/types/GraphqlSchema';

export const INDUSTRY_TRACKER_IMAGES = {
  [IndustryTrackerTypeEnum.PotentialMaOpportunities]: LicensingImg,
  [IndustryTrackerTypeEnum.ExplorationAndAppraisalWellTracker]: OffshoreExplorationImg,
  [IndustryTrackerTypeEnum.LicensingRoundAndDroTracker]: LicensingRoundImg,
  [IndustryTrackerTypeEnum.CapexGuidanceTracker]: CapexGuidanceTrackerImg,
  [IndustryTrackerTypeEnum.EnergyTransitionTargetsTracker]: EnergyTransitionTargetsTrackerImg,
  [IndustryTrackerTypeEnum.LngFacilities]: LNGFacilitiesImg,
};
